import keyMirror from 'keymirror'

export const ActionTypes = keyMirror({
  LOAD_DATA_STARTED: null,
  LOAD_DATA_COMPLETED: null,
  LOAD_DATA_FAILED: null,

  CHANGE_RANGE: null,

  SET_HOVERED_NODE: null,
  SET_HOVERED_COLOR: null,

  PUBLISH_BUBBLES_STARTED: null,
  PUBLISH_BUBBLES_COMPLETED: null,
  PUBLISH_BUBBLES_FAILED: null,
  PUBLISH_BUBBLES_CLOSE: null,
})

export const PayloadSources = keyMirror({
  SERVER_ACTION: null,
  VIEW_ACTION: null,
})
